<template>
  <div class="dashboard" :class="isClose && 'close'" @click="moveLocationToBA">
    <div class="dashboard__close-btn" @click.stop="toggleDashboard">
      <a class="arrow"></a>
      <div class="mask"></div>
    </div>
    <div class="dashboard__hidden-text">Journey Map</div>
    <i class="dashboard__logo"></i>
    <h2 class="dashboard__title">Journey Map</h2>
    <span class="dashboard__contents">{{ $t('gnb.dashboard.desc') }}</span>
    <span class="dashboard__sub-contents">{{ $t('gnb.dashboard.subDesc') }}</span>
  </div>
</template>

<script>
import { storageManager, STORAGE_KEY } from '../../libs/storage-manager'
import { BA_URL } from '../../libs/utils'

export default {
  name: 'JourneyDashboard',
  data () {
    return {
      isClose: false
    }
  },
  created () {
    this.isClose = storageManager.getItem(STORAGE_KEY.closeDashboard)
  },
  methods: {
    toggleDashboard () {
      storageManager.setItem(STORAGE_KEY.closeDashboard, !this.isClose)
      this.isClose = !this.isClose
    },
    moveLocationToBA () {
      window.location.href = BA_URL + '/tool'
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  position: fixed;
  left: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 5px;

  box-sizing: border-box;
  width: 190px;
  height: 254px;
  border-radius: 7px;
  padding: 34px 15px 0px 15px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);

  background: url(../../assets/img/analytics/lnb-journey.svg) no-repeat 88% 167%;
  background-color: #fff;

  z-index: 5;
  transition: all 1s cubic-bezier(0.23, 1, 0.32, 1);

  cursor: pointer;

  &.close {
    bottom: -231px;
  }

  &__close-btn {
    position: absolute;
    top: -15px;
    right: 26px;

    width: 25px;
    height: 14px;
    border-radius: 3px 3px 0px 0px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
    border-bottom: 0px;

    background-color: #fff;

    cursor: pointer;

    .arrow {
      position: absolute;
      left: 50%;
      top: 0px;
      transform: translate(-50%, 2px);

      width: 14px;
      height: 14px;
      background: url(../../assets/img/icon-down-black.svg) no-repeat center 100%;
    }

    .mask {
      position: absolute;
      bottom: -1px;

      width: 100%;
      height: 2px;
      background-color: #fff;

      z-index: 10;
    }
  }

  &.close {
    .dashboard__close-btn .arrow {
        background: url(../../assets/img/icon-up-black.svg) no-repeat center 100%;
    }
  }

  &__hidden-text {
    position: absolute;
    left: 8px;
    top: 5px;

    font-family: "rubrik-new";
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -0.18px;
    color: #ec0047;
    opacity: 0;

    transition: opacity 1s ease-in-out;
  }

  &.close {
    .dashboard__hidden-text {
        opacity: 1;
    }
  }

  &__logo {
    width: 70px;
    height: 12px;
    background-image: url(../../assets/img/logo-new.svg);
    background-size: cover;
  }

  &__title {
    font-family: "rubrik-new";
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -0.37px;
    text-align: center;
    color: #ec0047;
  }

  &__contents {
    margin-top: 5px;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.25px;
    text-align: center;
    color: #333;
  }

  &__sub-contents {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.18px;
    text-align: center;
    color: #616161;
  }
}
</style>
